// extracted by mini-css-extract-plugin
export default {"form-fields":"styles_form-fields__pqkw8","inputs-id":"styles_inputs-id__nZPvR","registration-input":"styles_registration-input__r4P+V","input-error":"styles_input-error__k-MrI"};